import React, { useState } from "react";
import {
  Row,
  Column,
  FormGroup,
  TextArea,
  RadioButtonGroup,
  RadioButton,
  TextInput,
} from "carbon-components-react";
import useAuth from "../../hooks/useAuth";

const WorkersForm = ({
  disabled,
  register,
  errors,
  hasBusinessCurrently,
  setHasBusinessCurrently,
}) => {
  const [stats, setStats] = useState([]);
  return (
    <FormGroup legendText="6	COLABORADORES" className="section-header">
      <h6 className="section-subtitle">
        A ser preenchida por todos/as candidatos/as independentemente se tem ou
        não um negócio actualmente.
      </h6>
      <fieldset className="bx--fieldset required">
        <legend className="bx--label">
          6.1 Número actual de colaboradores{" "}
        </legend>
        <div className="bx--form__helper-text">
          [Preencha os dados requeridos na tabela abaixo relativos aos
          colaboradores (incluindo os proprietários/as - trabalhadores/as, e
          nunca usando nomes de pessoas]
        </div>
        <table className="table table-bordered ">
          <thead className="thead-light">
            <tr>
              <th scope="col">Descrição</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Número actual total de trabalhadores (Homens)</strong>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="currentMales"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.currentMales")}
                />
                <p className="field-error">
                  {errors.workers?.currentMales?.message}
                </p>
              </td>
            </tr>
            <tr>
              <td>
                Dos quais, colaboradores da faixa etária dos 18 a 35 anos
                perfazem o número de:
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="currentMalesAged18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.currentMalesAged18To35")}
                />
                <p className="field-error">
                  {errors.workers?.currentMalesAged18To35?.message}
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <strong>
                  Número actual total de trabalhadoras (Mulheres){" "}
                </strong>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="currentFemales"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.currentFemales")}
                />
                <p className="field-error">
                  {errors.workers?.currentFemales?.message}
                </p>
              </td>
            </tr>
            <tr>
              <td>
                Dos quais, colaboradores da faixa etária dos 18 a 35 anos
                perfazem o número de:
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="currentFemalesAged18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.currentFemalesAged18To35")}
                />
                <p className="field-error">
                  {errors.workers?.currentFemalesAged18To35?.message}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </fieldset>

      <fieldset className="bx--fieldset required">
        <legend className="bx--label">6.2 Pessoal Necessário até 2025 </legend>
        <div className="bx--form__helper-text">
          [Preencha os dados requeridos na tabela abaixo relativos aos
          colaboradores (incluindo os proprietários/as - trabalhadores/as, e
          nunca usando nomes de pessoas.{" "}
          <strong>
            Caso se trate de um negócio ainda não existente num determinado ano,
            por favor, coloque o número zero (0), na célula correspondente da
            tabela
          </strong>
          ]
        </div>
        <table className="table table-bordered ">
          <thead className="thead-light">
            <tr>
              <th scope="col">Descrição</th>
              <th scope="col">2023</th>
              <th scope="col">2024</th>
              <th scope="col">2025</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Número actual total de trabalhadores (Homens)</strong>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="males2022"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.males2022")}
                />
                <p className="field-error">
                  {errors.workers?.males2022?.message}
                </p>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="males2023"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.males2023")}
                />
                <p className="field-error">
                  {errors.workers?.males2023?.message}
                </p>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="males2024"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.males2024")}
                />
                <p className="field-error">
                  {errors.workers?.males2024?.message}
                </p>
              </td>
            </tr>
            <tr>
              <td>
                Dos quais, colaboradores da faixa etária dos 18 a 35 anos
                perfazem o número de:
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="males2022Aged18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.males2022Aged18To35")}
                />
                <p className="field-error">
                  {errors.workers?.males2022Aged18To35?.message}
                </p>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="males2023Aged18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.males2023Aged18To35")}
                />
                <p className="field-error">
                  {errors.workers?.males2023Aged18To35?.message}
                </p>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="males2024Aged18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.males2024Aged18To35")}
                />
                <p className="field-error">
                  {errors.workers?.males2024Aged18To35?.message}
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <strong>
                  Número actual total de trabalhadoras (Mulheres){" "}
                </strong>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="females2022"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.females2022")}
                />
                <p className="field-error">
                  {errors.workers?.females2022?.message}
                </p>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="females2023"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.females2023")}
                />
                <p className="field-error">
                  {errors.workers?.females2023?.message}
                </p>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="females2024"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.females2024")}
                />
                <p className="field-error">
                  {errors.workers?.females2024?.message}
                </p>
              </td>
            </tr>
            <tr>
              <td>
                Dos quais, colaboradores da faixa etária dos 18 a 35 anos
                perfazem o número de:
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="females2022Aged18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.females2022Aged18To35")}
                />
                <p className="field-error">
                  {errors.workers?.females2022Aged18To35?.message}
                </p>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="females2023Aged18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.females2023Aged18To35")}
                />
                <p className="field-error">
                  {errors.workers?.females2023Aged18To35?.message}
                </p>
              </td>
              <td>
                <TextInput
                  labelText=""
                  id="females2024Aged18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("workers.females2024Aged18To35")}
                />
                <p className="field-error">
                  {errors.workers?.females2024Aged18To35?.message}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </fieldset>
    </FormGroup>
  );
};

WorkersForm.defaultProps = {
  disabled: false,
};
export default WorkersForm;
